import { useEffect, useState } from "react";

function useFetch(url) {
  const [data, setData] = useState([]);

  useEffect(() => {
    async function getData() {
      try {
        const result = await fetch(url, {
          method: "GET",
          credentials: "include",
        });
        const clients = await result.json();
        setData(clients.data);
      } catch (err) {
        console.log(err);
      }
    }

    getData();
  }, [url]);
  return [data];
}

export default useFetch;
